/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentStatus {
    INCOMPLETE = 'INCOMPLETE',
    COMPLETE = 'COMPLETE',
    COMPLETED_OUTSIDE_DEALSTACK = 'COMPLETED_OUTSIDE_DEALSTACK',
    PENDING = 'PENDING',
    NA = 'NA',
}
